export default __webpack_public_path__ + "static/media/1.024d235a.png";